import {
  isHighwayArea,
  isManualArea,
  isRackingArea,
  isSingularStationArea,
  isStationaryArea,
} from '@/modules/floorplanDesign/helpers/typeguards';
import { Area } from '@/modules/floorplanDesign/types';
import { Obstacle,  Templates, Group } from '@thive/fddm-types';

export const hasOnlySingleHighwayArea = (areas: Area[]) =>
  areas.length === 1 && isHighwayArea(areas[0]);
export const hasOnlySingleSingularStationArea = (areas: Area[]) =>
  areas.length === 1 && isSingularStationArea(areas[0]);
export const hasOnlyManualArea = (areas: Area[]) => areas.length === 1 && isManualArea(areas[0]);
export const hasOnlySingleStationaryArea = (areas: Area[]) =>
  areas.length === 1 && isStationaryArea(areas[0]);
export const hasOnlySingleRackingArea = (areas: Area[]) =>
  areas.length === 1 && isRackingArea(areas[0]);
export const hasOnlySingleLassieTemplate = (templates: Templates) =>
  templates.lassies.length === 1 &&
  templates.lassieMinis.length === 0 &&
  templates.shuttleRacks.length === 0 &&
  (!templates.hikStorages || templates.hikStorages.length === 0);
export const hasOnlySingleLassieMiniTemplate = (templates: Templates) =>
  templates.lassieMinis.length === 1 &&
  templates.lassies.length === 0 &&
  templates.shuttleRacks.length === 0 &&
  (!templates.hikStorages || templates.hikStorages.length === 0);
export const hasOnlySingleShuttleRackTemplate = (templates: Templates) =>
  templates.shuttleRacks.length === 1 &&
  templates.lassies.length === 0 &&
  templates.lassieMinis.length === 0 &&
  (!templates.hikStorages || templates.hikStorages.length === 0);
export const hasOnlySingleHikTemplate = (templates: Templates) =>
  templates?.hikStorages?.length === 1 &&
  templates.lassies.length === 0 &&
  templates.lassieMinis.length === 0 &&
  templates.shuttleRacks.length === 0;
export const hasOnlySingleObstacle = (obstacles: Obstacle[]) =>
  obstacles.length === 1 && obstacles[0].appearance !== 'WALL';
export const hasOnlySingleWallObstacle = (obstacles: Obstacle[]) =>
  obstacles.length === 1 && obstacles[0].appearance === 'WALL';
export const hasOnlySingleGroup = (groups: Group[]) => groups.length === 1;
